module.exports = __webpack_public_path__ + "img/康迪泰克.png";